import {InstitutionRepository} from "@web-libs/features/institution/domain/institution.repository";
import {HttpClient} from "@web-libs/core/http";
import {AllInstitutionsTag, getInstitutionTag} from "@web-libs/features/institution/api/institution.tags";
import {Page, unwrapPage} from "@web-libs/core/pagination/api/pagination.functions";
import {Institution} from "@web-libs/features/institution/domain/institution.types";

export const createInstitutionRepository = (httpClient: HttpClient): InstitutionRepository => {
    return {
        getAllInstitutions: async () => {
            const response = await httpClient.get<Page<Institution>>('/public/institutions', {tags: [AllInstitutionsTag]})
            return unwrapPage(response)
        },
        getInstitutionById: async (id: string) => {
            return httpClient.get(`/public/institutions/${id}`, {tags: [getInstitutionTag(id)]})
        }
    }
}
